// extracted by mini-css-extract-plugin
export default {"contentBlock":"CameraSettingsPage_contentBlock__lnP0R","ant-checkbox-group":"CameraSettingsPage_ant-checkbox-group__Ogju0"};